import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserData } from '../../core/core.interface'

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public mapView: string = 'VIDEOS';
  private isLoggedInSubject = new BehaviorSubject<boolean>(!!localStorage.getItem('userData'));
  isLoggedIn$ = this.isLoggedInSubject.asObservable();
 
   login(userData: UserData): void {
    localStorage.setItem('isUserLoggedin', 'true');
    localStorage.setItem('userData', JSON.stringify(userData));
     this.isLoggedInSubject.next(true);  
   }

   logout(): void {
    localStorage.removeItem('isUserLoggedin');
    localStorage.removeItem('userData');
     this.isLoggedInSubject.next(false); 
   }

   isUserLoggedIn(): boolean {
     return this.isLoggedInSubject.value;
   }

   getUserData(): UserData | null {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  }
}
